<ng-container *ngIf="ngIfCondition || !useNgIf">
    <ng-content></ng-content>
</ng-container>
